<template>
  <div :class="[rootClass, 'news-page-container']">
    <div class="news-container">
      <h2>{{ title }}</h2>

      <div v-if="loading">加载中...</div>
      <div v-else-if="newsList.length > 0" class="news-list">
        <div
          v-for="(item, index) in newsList"
          :key="item.id"
          class="news-item"
          @click.stop="goToDetail(item)"
        >
          <div class="news-content">
            <div class="news-image">
              <img :src="item.thumbnail" :alt="item.articleTitle" />
            </div>

            <div class="news-info">
              <h3 class="news-title">{{ item.articleTitle }}</h3>
              <p class="news-subhead">{{ item.subhead }}</p>
              <div class="news-time">
                <span v-if="item.createTime">{{ formatDate(item.createTime) }}</span>
              </div>
            </div>
          </div>

          <div v-if="index < newsList.length - 1" class="news-divider"></div>
        </div>
      </div>
      <div v-else>暂无数据</div>

      <div v-if="total > 0" class="pagination-wrapper">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :current-page.sync="currentPage"
          :page-size="resolvedPageSize"
          @current-change="handlePageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { getNewsListApi } from '@/API/news.js'
  import { getCategoryIdByName } from '@/utils/getCategoryId.js'
  import { formatDate } from '@/utils/dateUtils.js'
  import { navigateToNews } from '@/utils/newsNavigation.js'

  export default {
    name: 'NewsListPage',
    props: {
      title: {
        type: String,
        required: true
      },
      categoryName: {
        type: String,
        required: true
      },
      categoryPath: {
        type: String,
        required: true
      },
      rootClass: {
        type: String,
        default: ''
      },
      pageSize: {
        type: Number,
        default: 6
      }
    },
    data() {
      return {
        newsList: [],
        loading: false,
        currentPage: 1,
        total: 0
      }
    },
    computed: {
      resolvedPageSize() {
        return this.pageSize || 6
      }
    },
    mounted() {
      this.getNewsList()
    },
    methods: {
      async getNewsList() {
        this.loading = true
        try {
          const categoryIdentification = await getCategoryIdByName(this.categoryName)

          if (!categoryIdentification) {
            console.error('未找到对应的分类标识')
            this.newsList = []
            this.total = 0
            return
          }

          const res = await getNewsListApi(categoryIdentification, this.currentPage, this.resolvedPageSize)

          if (res && res.data) {
            this.newsList = res.data.list || res.data.records || res.data || []
            this.total = res.data.total || res.data.totalCount || 0
          }
        } catch (error) {
          console.error('获取新闻列表失败：', error)
        } finally {
          this.loading = false
        }
      },

      handlePageChange(page) {
        this.currentPage = page
        this.getNewsList()
      },

      async goToDetail(newsItem) {
        await navigateToNews(newsItem, this.categoryPath, this.$router)
      },

      formatDate
    }
  }
</script>

<style scoped lang="scss">
  @import '@/styles/news-list-common.scss';
</style>

